import type { ReactNode } from 'react';

/** Renders a dialog the page supplied through a render prop. Going through a component (rather than calling the prop inline in the parent's render) keeps
 * the parent's refs and handlers out of a function that runs during render. */
export function RenderSlot<P>({ render, props }: { render: (props: P) => ReactNode; props: P }) {
  return <>{render(props)}</>;
}
